import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a36f89df7111800145c55ea_1787421324145_27c65ccc/aimakerstudio/src/app/sign-up-login-screen/components/AuthScreen.tsx");
